import cloneDeep from 'lodash/cloneDeep';
import { getAll } from '@/api/produit/index';
import { CLASS_NIVEAU_DISPONIBILITE } from '@/configuration/catalogue/disponibiliteConf';
import genererCritereRechercheCatalogueProduitNonCom
  from '@/services/catalogue/genererCriteresRecherche/genererCritereRechercheCatalogueProduitNonCom';
import transform from '@/services/catalogue/filters/produitServerTableDataTransformer';
import * as types from './produit-mutation-type';
import * as allTypes from '../mutation-type';

function initialState() {
  return {
    produits: [],
    produitsAssocies: [],
    totalProduits: 0,
    totalProduitsAssocies: 0,
    produit: null,
    criteresRechercheProduitNonCom: genererCritereRechercheCatalogueProduitNonCom(),
    selection: [],
    societeForGetAll: null,
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_PRODUITS](state, produits) {
    state.produits = produits;
  },
  [types.SET_PRODUITS_ASSOCIES](state, produitsAssocies) {
    state.produitsAssocies = produitsAssocies;
  },
  [types.SET_PRODUIT](state, produit) {
    state.produit = produit;
  },
  [types.REMOVE_PRODUIT](state) {
    state.produit = null;
  },
  [types.SET_SELECTION](state, selection) {
    state.selection = selection;
  },
  [types.SET_SOCIETE_FOR_GET_ALL](state, societeForGetAll) {
    state.societeForGetAll = societeForGetAll;
  },
  [types.SET_TOTAL_PRODUITS](state, totalProduits) {
    state.totalProduits = totalProduits;
  },
  [types.SET_TOTAL_PRODUITS_ASSOCIES](state, totalProduitsAssocies) {
    state.totalProduitsAssocies = totalProduitsAssocies;
  },
  [types.SET_CRITERE_RECHERCHE_PRODUIT_NON_COM](state, critereRecherche) {
    state.criteresRechercheProduitNonCom = critereRecherche;
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadProduits({ commit }, data) {
    data.query.filteredByModule = true;
    const response = await getAll(data);
    response.data.result.items.forEach((item) => {
      item.affectations = '';
      item.decoration = {
        dispoClass: CLASS_NIVEAU_DISPONIBILITE[item.disponibilite],
      };
      item.selected = false;
    });
    commit(types.SET_LAST_PAYLOAD, transform(data));
    commit(types.SET_TOTAL_PRODUITS, response.data.result.totalCount);
    commit(types.SET_PRODUITS, response.data.result.items);
    return {};
  },
  updateSelection({ commit }, selection) {
    commit(types.SET_SELECTION, selection);
  },
  updateProduit({ commit }, produit) {
    commit(types.SET_PRODUIT, produit);
  },
  updateSocieteForGetAll({ commit }, societeForGetAll) {
    commit(types.SET_SOCIETE_FOR_GET_ALL, societeForGetAll);
  },
  addLiaisonTarifInSelection({ commit, getters }, liaisonTarif) {
    let produitPresse = null;
    ['produitAutre', 'produitPresse', 'produitSalon', 'produitSponsoring'].forEach(el => {
      if (getters.produit[el]) produitPresse = getters.produit[el];
    });
    const selection = cloneDeep(state.selection);
    if (produitPresse) {
      liaisonTarif.dateDebut = produitPresse.dateDebut;
      liaisonTarif.dateFin = produitPresse.dateFin;
    }
    selection.unshift(liaisonTarif);
    commit(types.SET_SELECTION, selection);
  },
  deleteLiaisonTarifInSelection({ commit }, deleteObject) {
    const selectionWithLigneToDelete = state.selection.filter((ligne) => {
      return ligne.isAlreadySelect === deleteObject.isAlreadySelect;
    });
    selectionWithLigneToDelete.splice(deleteObject.index, 1);
    const selectionWithoutLigneToDelete = state.selection.filter((ligne) => {
      return ligne.isAlreadySelect === !deleteObject.isAlreadySelect;
    });
    const selection = selectionWithLigneToDelete.concat(selectionWithoutLigneToDelete);
    commit(types.SET_SELECTION, selection);
  },
  async loadProduitsLocAndDivers({ commit }, data) {
    const response = await getAll(data);
    response.data.result.items.forEach((item) => {
      item.selected = false;
    });
    commit(types.SET_TOTAL_PRODUITS_ASSOCIES, response.data.result.totalCount);
    commit(types.SET_PRODUITS_ASSOCIES, response.data.result.items);
    return {};
  },
};

const getters = {
  produits: state => {
    return state.produits;
  },
  produitsAssocies: state => {
    return state.produitsAssocies;
  },
  totalProduits: state => {
    return state.totalProduits;
  },
  totalProduitsAssocies: state => {
    return state.totalProduitsAssocies;
  },
  produit: state => {
    return state.produit;
  },
  criteresRechercheProduitNonCom: state => {
    return state.criteresRechercheProduitNonCom;
  },
  selection: state => {
    return state.selection;
  },
  societeForGetAll: state => {
    return state.societeForGetAll;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
